/**
 * Benefits and perks sub page
 * In the future these subpages will be automatically generated through gatsby-node.js
 *
 * Copyright (c) 2020 Coursera
 *
 */
import React from 'react'
import Layout from 'components/Layout'
import SectionWrapper from 'components/SectionWrapper'
import ContentfulSubPage from 'components/contentful/ContentfulSubPage'
import { graphql, useStaticQuery } from 'gatsby'
import { Helmet } from 'react-helmet'
import cx from 'classnames'
import styles from './Jobs.module.scss'

const Jobs = (props) => {
  const data = useStaticQuery(graphql`
    query {
      contentfulPage(slug: { eq: "jobs" }) {
        ...PageFragment
      }
    }
  `)

  const JobsPage = data?.contentfulPage || {}
  console.log(JobsPage)
  return (
    <Layout {...props} {...JobsPage}>
      <SectionWrapper className={cx(styles.board)}>
        <Helmet>
          <script src="https://boards.greenhouse.io/embed/job_board/js?for=coursera" />
        </Helmet>
        <div id="grnhse_app" />
      </SectionWrapper>
    </Layout>
  )
}

export default Jobs
